<p class="col-12 p-t-4 p1"
   *ifTradeStore>
    @switch (store.isOpenToday && store.isOpenNow) {
    @case (true) {
    <span class="col-3 p-r-8 pos-relative open">{{'Open' | translate}}</span>
    {{ 'Closes at' | translate}} {{store.todayOpeningHours?.close}}
    }
    @default {
    <span>{{'Closed' | translate}}
    </span>
    }
    }
</p>